export default __webpack_public_path__ + "static/media/MP0049.6e503e07.jpg";